import React, { useState } from 'react'
import classes from './Nav.module.css';
function Nav() {
  const days=["Sunday","Monday","Thuesday","wednesday","Thursday","Friday","Satureday"];
  const months=["January","February","March","April","May","June","July","August","September","October","November","December"];
  const [d,setd]=useState();
   
  let nowtime;
  setInterval(()=>{
    nowtime=new Date();
    setd(nowtime); 
  },1000);
  
  return (
    <>
    {d && <div>
      <h3 className={classes.time}>{`${d.getHours()} : ${d.getMinutes()} : ${d.getSeconds()}`}</h3>
      <h4 className={classes.dateTime}>{`${days[(d.getDay())]}, ${d.getDate()} ${months[(d.getMonth())]} ${d.getFullYear()}`}</h4>
    </div>}
    </>
  )
}

export default Nav